import DatabaseService from 'services/DatabaseService.js';
import {SET_PLUGINS} from 'actions/types'; 
import {isListLoaded,
        getPlugins, 
        getPlugin, 
        getPluginsByTypeTag}  from 'reducers/plugins.js'

//Action Creators
export const setPlugins = (plugins) => {
    return { type:SET_PLUGINS, plugins:plugins };
}


//Thunks
export const fetchPlugins = (params, force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isListLoaded(state.plugins)) {
            return Promise.resolve(getPlugins(state.plugins));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.fetchPlugins(params).then(
            function(result) { 
                dispatch(setPlugins(result.plugins));
                resolve(result);
            },
            function(error){ 
                console.error(error);
                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/actions/plugins.js